module.exports = __webpack_public_path__ + "img/skills-lf-ama-1.67c069cf.png";